import { call, takeLatest } from 'redux-saga/effects';
import actionTypes from '../../actions/actionTypes';
import { getPrintDataCall } from '../../apis/wpApi/apiCalls';
import getCurrentWeeksArray from '../../functions/getCurrentWeeksArray';
import { putSuccess, putError } from '../helpers'
import authUser from '../../apis/wpApi/authUser';



function* getData({payload}) {
    try {
        const currentWeeks = yield getCurrentWeeksArray()
        const apiKey = yield call(authUser.getToken)
        const response = yield call(getPrintDataCall, apiKey, payload.signal)

        if(!response || !response.status || 200 !== response.status || !response.data || !response.data.flyer || !response.data.generalSettings) {
            throw new Error('Could not update data')
        } else {
            const generalSettings = yield response.data.generalSettings
            const flyerData = yield response.data.flyer
            const weekProgramFlyerData = yield response.data.weekProgramFlyer
            const newspaperData = yield response.data.newspaper

            if(!flyerData.weeks || currentWeeks[0] != parseInt(flyerData.weeks[0])) {
                flyerData.weeks = currentWeeks
            }

            if(!flyerData.currentWeek || !currentWeeks.includes(parseInt(flyerData.currentWeek))) {
                flyerData.currentWeek = currentWeeks[1]
            }
            
            if(!weekProgramFlyerData.weeks || currentWeeks[0] != parseInt(weekProgramFlyerData.weeks[0])) {
                weekProgramFlyerData.weeks = currentWeeks
            }

            if(!weekProgramFlyerData.currentWeek || !currentWeeks.includes(parseInt(weekProgramFlyerData.currentWeek))) {
                weekProgramFlyerData.currentWeek = currentWeeks[1]
            }
            
            if(!newspaperData.weeks || currentWeeks[0] != parseInt(newspaperData.weeks[0])) {
                newspaperData.weeks = currentWeeks
            }

            if(!newspaperData.currentWeek || !currentWeeks.includes(parseInt(newspaperData.currentWeek))) {
                newspaperData.currentWeek = currentWeeks[1]
            }

            yield putSuccess(actionTypes.PRINT_DATA_GET_SUCCESS, {
                flyer: flyerData, 
                weekProgramFlyer: weekProgramFlyerData, 
                generalSettings: generalSettings,
                newspaper: newspaperData
            })
        }
    } catch(e) {
        console.log('ERROR', e)
        yield putError(actionTypes.PRINT_DATA_GET_ERROR, e.message)
    }
}


function* watchPrintGetRequest() {
    yield takeLatest(actionTypes.PRINT_DATA_GET_REQUEST, getData);
}

export default watchPrintGetRequest